import { render, staticRenderFns } from "./AppToCheckout.vue?vue&type=template&id=b42e024c&scoped=true&"
import script from "./AppToCheckout.vue?vue&type=script&lang=js&"
export * from "./AppToCheckout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42e024c",
  null
  
)

export default component.exports